import { render } from "./EspeciesView.vue?vue&type=template&id=d6dc96a2"
import script from "./EspeciesView.vue?vue&type=script&lang=js"
export * from "./EspeciesView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__